<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="120px"
      label-position="right">
      <el-form-item label="景点名称" prop="sceneryName">
        <el-input v-model="formData.sceneryName" placeholder="请输入景点名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属公园" prop="projectId">
        <el-select v-model="formData.projectId" placeholder="请选择所属公园" clearable filterable @change="changePark">
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否网红景点" prop="isNetRed">
        <el-radio-group v-model="formData.isNetRed" width="110px">
          <el-radio label="0" border>否</el-radio>
          <el-radio label="1" border>是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="fileList">
        <template slot="label">
          <span>景点封面图<br>(最多六张)</span>
        </template>
        <custom-upload v-model="formData.fileList"></custom-upload>
      </el-form-item>
      <el-form-item label="景点介绍" prop="description">
        <!-- <el-input type="textarea" placeholder="请输入景点介绍" v-model="formData.description"
          maxlength = "1000"
          :rows="8"
          show-word-limit>
        </el-input> -->
        <custom-editor ref="editor" v-model="formData.description"></custom-editor>
      </el-form-item>
      <el-form-item label="景点位置" prop="resourcesLocationList">
        <div class="map">
          <el-button class="button" type="primary" @click="getInput">手动输入</el-button>
          <CustomMapMarker ref="map" :isClickPolyon="false" @input="getPosition"
            :value="formData.resourcesLocationList">
          </CustomMapMarker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit" :disabled="disabled">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>

    <SetLatLngDialog :isShowInput.sync="isShowInput" :value="formPosition" @getlnglat='getlnglat'></SetLatLngDialog>
  </el-card>
</template>

<script>
import SetLatLngDialog from '@/components/SetLatLngDialog'
import { handleTLnglatList } from '@/utils/util'
import CustomEditor from '@/components/CustomEditor.vue'
export default {
  name: 'ScenicspotAdd',
  components: {
    SetLatLngDialog,
    CustomEditor
  },
  data() {
    return {
      isShowInput: false,
      disabled: false,
      parkList: [],
      mapRef: null,
      formData: {
        projectId: '',
        sceneryName: '',
        isNetRed: '',
        isFull: '',
        description: '',
        fileList: [],
        resourcesLocationList: []
      },
      formPosition: {
        longitude: '',
        latitude: ''
      },
      rules: {
        sceneryName: [
          { required: true, message: '请输入景点名称', trigger: ['blur', 'change'] }
        ],
        projectId: [
          { required: true, message: '请输入所属公园', trigger: ['blur', 'change'] }
        ],
        isNetRed: [
          { required: true, message: '请选择是否网红景点', trigger: ['blur', 'change'] }
        ],
        fileList: [
          { required: true, message: '请选择景点封面图', trigger: ['blur', 'change'] }
        ],
        description: [
          { required: true, message: '请输入景点介绍', trigger: ['blur', 'change'] }
        ],
        resourcesLocationList: [
          { required: true, message: '请选择景点位置', trigger: ['blur', 'change'] }
        ]
      },
      polygonOverlays: [], // 用于存储多边形覆盖物的数组
    }
  },
  computed: {
    sceneryId() {
      return this.$route.params.sceneryId || ''
    },
    projectId() {
      return this.$route.query.projectId || ''
    }
  },
  created() {
    this.getPark()
    if (this.sceneryId) {
      this.loadData()
    }
  },
  mounted() {
    this.mapRef = this.$refs.map
    // this.initMap()
    this.projectId && this.drawPolyon(this.projectId)
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    changePark(val) {
      this.drawPolyon(val)
    },
    // initMap() {
    //   // 初始化地图
    //   this.mapRef = new AMap.Map('map', {
    //     zoom: 10,
    //     center: [116.397428, 39.90923]
    //   });
    // },
    // 围栏
    drawPolyon(projectId) {
      this.$axios.get(this.$apis.project.selectYhProjectMapByProjectId, {
        projectId: projectId
      }).then(res => {
        const parkInfo = res || {}
        // 绘制公园中心点
        // this.center = [{ longitude: parkInfo.longitude, latitude: parkInfo.latitude }]
        // 绘制电子围栏
        this.mapRef.setZoomAndCenter(15, [+parkInfo.longitude, +parkInfo.latitude])
        this.fenceList = handleTLnglatList(res.locationList || [])

        // 重新绘制前清除所有多边形覆盖物
        this.polygonOverlays.forEach(overlay => {
          overlay.setMap(null);
        });
        this.polygonOverlays = []; // 清空数组

        // 绘制多边形
       this.mapRef.drawPolyons(this.fenceList)
      }).finally(() => {
        this.loading = false
      })
    },
    loadData() {
      this.$axios.get(this.$apis.tourist.selectSceneryBySceneryId, {
        sceneryId: this.sceneryId
      }).then(res => {
        this.formData = res || {}
      })
    },
    // 获取打点经纬度
    getPosition(val) {
      this.formData.resourcesLocationList = val
    },
    getInput() {
      this.isShowInput = true
      if (this.formData.resourcesLocationList[0]) {
        this.formPosition = JSON.parse(JSON.stringify(this.formData.resourcesLocationList[0]))
      }
    },
    getlnglat(val) {
      this.formData.resourcesLocationList = JSON.parse(JSON.stringify([{ ...val }]))
      const lngLat = [+this.formData.resourcesLocationList[0].longitude, +this.formData.resourcesLocationList[0].latitude]
      this.mapRef.setZoomAndCenter(lngLat)
    },
    onInput(value) {
      this.formData.description = value
    },
    submit() {
      this.$refs.form.validate().then(() => {
        this.disabled = true
        const url = this.sceneryId ? this.$apis.tourist.updateScenery : this.$apis.tourist.insertScenery
        this.$axios.post(url, this.formData).then(() => {
          this.$router.push('/scenicspot')
        }).finally(() => {
          this.disabled = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-textarea {
  width: 800px;
}

.map {
  position: relative;

  .button {
    position: absolute;
    top: 130px;
    left: 695px;
    z-index: 1000;
  }
}
</style>
